module.exports = __webpack_public_path__ + "img/other-actions.a5021da8.svg";